import React from 'react';

type AlertStatus = 'active' | 'triggered' | 'cancelled';

interface Props {
  status: AlertStatus;
}

export const StatusBadge: React.FC<Props> = ({ status }) => {
  const getStyles = (status: AlertStatus) => {
    switch (status) {
      case 'active':
        return 'bg-[#4f8ff8]/10 text-cat-accent border-[#4f8ff8]/25';
      case 'triggered':
        return 'bg-[#10d98e]/10 text-cat-green border-[#10d98e]/25';
      case 'cancelled':
        return 'bg-gray-100 dark:bg-cat-elevated text-gray-500 dark:text-cat-text-muted border-gray-200 dark:border-cat-border';
      default:
        return 'bg-gray-100 dark:bg-cat-elevated text-gray-500 dark:text-cat-text-muted border-gray-200 dark:border-cat-border';
    }
  };

  return (
    <span className={`inline-flex items-center gap-2 rounded-lg px-2.5 py-0.5 text-[11px] font-semibold border ${getStyles(status)}`}>
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {status.toUpperCase()}
    </span>
  );
};
